// extracted by mini-css-extract-plugin
module.exports = {"detail":"nacelle-detail_detail_1Ot8j","listWrap":"nacelle-detail_listWrap_2yZ1R"};